import { render, staticRenderFns } from "./SubstationManagement.vue?vue&type=template&id=648763d9&scoped=true&"
import script from "./SubstationManagement.vue?vue&type=script&lang=js&"
export * from "./SubstationManagement.vue?vue&type=script&lang=js&"
import style0 from "./SubstationManagement.vue?vue&type=style&index=0&id=648763d9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648763d9",
  null
  
)

export default component.exports